import { bootstrapApplication } from '@angular/platform-browser';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { provideRouter } from '@angular/router';
import { routes } from './app/app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient } from '@angular/common/http';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth, connectAuthEmulator } from '@angular/fire/auth';
import { getFirestore, provideFirestore, connectFirestoreEmulator } from '@angular/fire/firestore';
import { getStorage, provideStorage, connectStorageEmulator } from '@angular/fire/storage';

// Add this line for older browser compatibility
import 'zone.js';  // Included with Angular CLI.

if (environment.production) {
  enableProdMode();
}

console.log('Starting Firebase initialization...');

try {
  // Initialize Firebase application first
  const app = initializeApp(environment.firebase);
  console.log('Firebase app initialized');
  
  const auth = getAuth(app);
  console.log('Firebase auth initialized');
  
  const firestore = getFirestore(app);
  console.log('Firebase firestore initialized');
  
  const storage = getStorage(app);
  console.log('Firebase storage initialized');

  // Connect to emulators if enabled in environment
  if (environment.useEmulators) {
    try {
      console.log('Connecting to Firebase emulators...');
      
      const authEmulator = environment.emulators.auth;
      connectAuthEmulator(auth, `http://${authEmulator.host}:${authEmulator.port}`);
      console.log(`Connected to Auth emulator at ${authEmulator.host}:${authEmulator.port}`);
      
      const firestoreEmulator = environment.emulators.firestore;
      connectFirestoreEmulator(firestore, firestoreEmulator.host, firestoreEmulator.port);
      console.log(`Connected to Firestore emulator at ${firestoreEmulator.host}:${firestoreEmulator.port}`);
      
      const storageEmulator = environment.emulators.storage;
      connectStorageEmulator(storage, storageEmulator.host, storageEmulator.port);
      console.log(`Connected to Storage emulator at ${storageEmulator.host}:${storageEmulator.port}`);
      
      console.log('Successfully connected to all Firebase emulators');
    } catch (e) {
      console.error('Failed to connect to emulators:', e);
    }
  } else {
    console.log('Firebase emulators are disabled. Using production Firebase services.');
  }

  // Bootstrap the application with Firebase services
  console.log('Bootstrapping Angular application...');
  bootstrapApplication(AppComponent, {
    providers: [
      provideRouter(routes),
      provideAnimations(),
      provideHttpClient(),
      // Use existing Firebase app and services
      provideFirebaseApp(() => app),
      provideAuth(() => auth),
      provideFirestore(() => firestore),
      provideStorage(() => storage),
      // Global service providers
    ]
  }).catch((err: Error) => {
    console.error('Error bootstrapping app:', err);
    document.body.innerHTML = `
      <div style="color: red; margin: 20px;">
        <h1>Application Error</h1>
        <p>There was an error starting the application:</p>
        <pre>${err.message}</pre>
        <p>Please check the console for more details.</p>
      </div>
    `;
  });
} catch (error) {
  console.error('Fatal error initializing Firebase:', error);
  document.body.innerHTML = `
    <div style="color: red; margin: 20px;">
      <h1>Firebase Initialization Error</h1>
      <p>There was an error initializing Firebase:</p>
      <pre>${error instanceof Error ? error.message : String(error)}</pre>
      <p>Please check the console for more details.</p>
    </div>
  `;
}
